export const defaultState = () => {
    return {
        defaults: [],
        params: {}
    }
}

const state = defaultState()
export default state
